export const splitTokens = (text) => (text || "").split(/(\s+)/).filter((token) => token.length > 0);

export const normalizeWord = (word) => word.toLowerCase().replace(/[^a-z0-9]/gi, "");

export const buildWordCounts = (text) => {
  const counts = new Map();
  (text || "")
    .split(/\s+/)
    .map(normalizeWord)
    .filter(Boolean)
    .forEach((word) => counts.set(word, (counts.get(word) || 0) + 1));
  return counts;
};

export const applyVocabularyRules = (text, rules) => {
  let output = text || "";
  rules.forEach((rule) => {
    if (!rule.applied || !rule.original || !rule.replacement) {
      return;
    }
    const pattern = new RegExp(`\\b${rule.original.replace(/[.*+?^${}()|[\\]\\]/g, "\\$&")}\\b`, "gi");
    output = output.replace(pattern, rule.replacement);
  });
  return output;
};
